<template>
  <QItem>
    <QItemSection>
      <div class="row items-center no-wrap">
        <div class="col">
          <QIcon name="eva-person-outline" size="24px" class="q-mr-sm" />
        </div>
        <span class="q-mr-md">View Profile</span>
        <div class="rounded-borders q-pa-sm bg-primary-light">
          <span class="text-primary"> {{ completion }}% completed </span>
        </div>
      </div>
      <QLinearProgress
        rounded
        track-color="grey-3"
        class="q-mt-md"
        color="primary"
        :value="completion / 100"
      />
      <div>
        <SAIBtn
          class="q-mt-md rounded-borders-lg"
          :rounded="false"
          outline
          :no-caps="true"
          v-close-popup
          label="Complete Profile"
          padding="sm md"
          @click="$emit('complete')"
        />
      </div>
    </QItemSection>
  </QItem>
</template>

<script>
import {
  QItem,
  QItemSection,
  QLinearProgress,
  QIcon,
  ClosePopup
} from 'quasar';
import { SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'UserProfileMenuStepper',
  props: {
    completion: Number
  },
  components: {
    QItem,
    QItemSection,
    QLinearProgress,
    SAIBtn,
    QIcon
  },
  directives: {
    ClosePopup
  }
};
</script>
